import { Link } from 'gatsby'
import { Layout } from '../components/common'

const NotFoundPage = () => (
    <Layout>
        <div id="site-main" className="site-main outer error-content">
            <div className="inner">
                <section className="error-message" >
                <div className="error_area">

                    <div className="container">
                        <div className="row ">
                            <section className="content-body col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                                <div className="title_head" style={{marginBottom:"20px",color:"#ffffff"}}>
                                    <span>Page not found</span>
                                </div>
                                <p className="title_spc">We’re sorry! The page you have looked for does not exist in our database!</p>
                                <div className="button-black transform"> <Link to="/" className="button-style banner_btn" style={{ backgroundColor:"#fff", borderColor:"#fff"}}>Go back to the homepage</Link></div>
                            </section>
                        </div>
                    </div>
                </div>
                </section>
            </div>
        </div>
    </Layout>
)

export default NotFoundPage
